/* ==========================================================================
   InputRxjs > Client > Loader
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');

const { actions, types } = require('../store/actions');

const configuration = require('../config');

const { LOADER_TEMPLATE } = require('../../../constants');

/* Add */
function addLoader(instance) {
    const { loader = false } = instance.hooks;

    if (loader) return;

    /* Close suggestions and syncValue */
    instance.actions.closeSuggestions();
    instance.actions.syncValue();

    const template = html(LOADER_TEMPLATE);

    const node = toNode(template)[0];

    const inst = instance;

    /* DOM */
    instance.element.classList.add(configuration().css.loading);
    instance.element.appendChild(node);

    /* Disable */
    instance.hooks.input.setAttribute('disabled', true);

    /* Hooks */
    inst.hooks = {
        ...instance.hooks,
        loader: instance.element.querySelector('[data-loader]')
    };
}

/* Remove */
function removeLoader(instance) {
    const { loader = false } = instance.hooks;

    if (!loader) {
        return;
    }

    const inst = instance;

    /* DOM */
    instance.element.removeChild(instance.hooks.loader);
    instance.element.classList.remove(configuration().css.loading);

    /* Enable */
    instance.hooks.input.removeAttribute('disabled');

    /* Hooks */
    delete inst.hooks.loader;
}

/* Init */
function initLoader(instance) {
    const inst = instance;

    /* Actions */
    inst.actions = {
        ...instance.actions,
        toggleLoading: () => instance.store.dispatch(actions.toggleLoading())
    };

    /* Reactions */
    inst.reactions = {
        ...instance.reactions,
        toggleLoading: instance.store.subscribe((state, action) => {
            if (action.type !== types.TOGGLE_LOADING) return;

            const { isLoading } = state.autocomplete;

            if (!isLoading) {
                /* Remove */
                removeLoader(instance);

                return;
            }

            /* Add */
            addLoader(instance);
        })
    };
}

/* Destroy */
function destroyLoader(instance) {
    /* Data */
    const { hasLoader } = instance.config;

    if (!hasLoader) {
        return;
    }

    const inst = instance;

    /* Reactions */
    instance.reactions.toggleLoading.unsubscribe();
    delete inst.reactions.toggleLoading;

    /* Actions */
    delete inst.actions.toggleLoading;
}

/* Exports */
module.exports = {
    initLoader,
    destroyLoader
};
